export const SSS_NATIONAL_ORGANISM_WITH_ACTE_REMUNERATION_PREFIX = '093';
export const SSS_NATIONAL_ORGANISM_WITH_MIXTE_REMUNERATION_PREFIX = '094';

export const SSS_NATIONAL_ORGANISM_LUMPSUM_CODES = ['xxx136', 'xxx137', 'xxx138'];

export const isSssNationalOrganismCode = (code) => SSS_NATIONAL_ORGANISM_LUMPSUM_CODES.includes(code);
